import {
  Group,
  NumberFormatter,
  SemiCircleProgress,
  SimpleGrid,
  Stack,
  Text,
  ThemeIcon,
  Title,
  Tooltip,
} from '@mantine/core'
import { IconInfoCircleFilled } from '@tabler/icons-react'
import { useTranslate } from 'react-admin'
import { useGetApiYoutubeQuotasLatest } from '../../codegen/generated/youtube-quotas'
import { LXLoader } from '../../components/LXLoader'
import { DateHelper, LONG_FORMAT } from '../../helpers/Date.helper'
import { QuotasHelper } from '../../helpers/Quotas.helper'

export const YoutubeQuotas = () => {
  const translate = useTranslate()

  const youtubeQuotasQuery = useGetApiYoutubeQuotasLatest()

  if (youtubeQuotasQuery.isLoading) {
    return <LXLoader />
  }

  return (
    <Stack gap="sm">
      <Group w="100%" justify="flex-end">
        <Text size="sm" c="dimmed">
          {translate('pages.quotas.quotasReset')} : {DateHelper.getQuotaResetTime()}
        </Text>
      </Group>
      <SimpleGrid cols={4} py="xl">
        {youtubeQuotasQuery.data?.body
          .sort((a, b) => a.quotaMetric.localeCompare(b.quotaMetric))
          .map(q => (
            <Stack gap="sm" align="center" key={q.id}>
              <Group gap="sm">
                <Title order={5}>{translate(`pages.quotas.services.${q.quotaMetric}.title`)}</Title>
                <Tooltip
                  label={translate(`pages.quotas.services.${q.quotaMetric}.description`)}
                  maw={350}
                  multiline
                >
                  <ThemeIcon variant="white" size="xs">
                    <IconInfoCircleFilled />
                  </ThemeIcon>
                </Tooltip>
              </Group>
              <SemiCircleProgress
                fillDirection="left-to-right"
                orientation="up"
                filledSegmentColor={QuotasHelper.getQuotaColor(q.usagePercent)}
                size={250}
                thickness={20}
                value={q.usagePercent}
                label={
                  <Stack gap="xs">
                    <Title order={3} c={QuotasHelper.getQuotaColor(q.usagePercent)}>
                      {q.usagePercent} %
                    </Title>
                    <Text size="sm" c="dimmed">
                      <NumberFormatter thousandSeparator=" " value={q.dailyUsage} /> /{' '}
                      <NumberFormatter thousandSeparator=" " value={q.dailyLimit} />
                    </Text>
                  </Stack>
                }
              />
              <Text size="xs" c="dimmed" mt="sm" fs="italic">
                {translate('pages.quotas.lastUpdate')}:{' '}
                {DateHelper.format(q.capturedAt, LONG_FORMAT)}
              </Text>
            </Stack>
          ))}
      </SimpleGrid>
    </Stack>
  )
}
